import { SUPPORTED_LOCALES } from "~/lib/locale";

// Keep this separate from the route tree so locale canonicalization cannot
// turn a legacy URL into a redirect before the server emits its direct 404.
export const RETIRED_AUTO_APPLY_PATHS = [
  "/auto-apply",
  "/auto-apply/queue",
  "/auto-apply/logs",
  "/auto-apply/settings",
] as const;

const escapedLocales = SUPPORTED_LOCALES.join("|");
const escapedPaths = RETIRED_AUTO_APPLY_PATHS
  .map((path) => path.slice(1).replace("/", "\\/"))
  .join("|");
const RETIRED_AUTO_APPLY_PATH = new RegExp(
  `^/(?:(?:${escapedLocales})/)?(?:${escapedPaths})/?$`,
);

export function isRetiredAutoApplyPath(pathname: string): boolean {
  return RETIRED_AUTO_APPLY_PATH.test(pathname);
}
